import {
  BatchSpanProcessor,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { Resource } from '@opentelemetry/resources'
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from '@opentelemetry/semantic-conventions'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { registerInstrumentations } from '@opentelemetry/instrumentation'

const OTEL_COLLECTOR_URL =
  import.meta.env.VITE_OTEL_COLLECTOR_URL || 'https://kuber-tempo.aminsaedi.com'

export function initTracing() {
  // Only run in browser
  if (typeof window === 'undefined') return

  // Skip if no collector URL configured
  if (!OTEL_COLLECTOR_URL) {
    console.log('[Tracing] VITE_OTEL_COLLECTOR_URL not set, tracing disabled')
    return
  }

  const resource = new Resource({
    [ATTR_SERVICE_NAME]: 'mashinato-pwa',
    [ATTR_SERVICE_VERSION]: '0.1.0',
  })

  const exporter = new OTLPTraceExporter({
    url: `${OTEL_COLLECTOR_URL}/v1/traces`,
  })

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [new BatchSpanProcessor(exporter)],
  })

  provider.register({
    contextManager: new ZoneContextManager(),
  })

  // Auto-instrument fetch calls to the API
  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [/kuber-carapi\.aminsaedi\.com/],
        clearTimingResources: true,
      }),
    ],
  })

  console.log('[Tracing] OpenTelemetry initialized')
}
